'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipientStatus = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RecipientStatus, _Component);

  function RecipientStatus() {
    var _ref;

    (0, _classCallCheck3.default)(this, RecipientStatus);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = RecipientStatus.__proto__ || (0, _getPrototypeOf2.default)(RecipientStatus)).call.apply(_ref, [this].concat(args)));

    var t = _this.props.t;

    _this.statusText = {
      Created: t('New'),
      EmailSent: t('Email Sent')
    };
    return _this;
  }

  (0, _createClass3.default)(RecipientStatus, [{
    key: 'render',
    value: function render() {
      var status = this.props.status;


      return _react2.default.createElement(
        'span',
        { className: 'recipientStatus ' + status },
        this.statusText[status] || status
      );
    }
  }]);
  return RecipientStatus;
}(_react.Component), _class2.propTypes = {
  status: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = RecipientStatus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/RecipientStatus.js
// module id = 845
// module chunks = 1